import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from './'

const Texts:LangFile = {
  // #region | General
  additional: "adicional",
  and: "y",
  change: "cambiar",
  choose: "elegir",
  deleteFailed: "error al eliminar",
  editFailed: "error al editar",
  filterBy: "filtrar por",
  from: "desde",
  general: "general",
  no: "no",
  noData: "Sin datos",
  noOptions: "Sin opciones",
  of: "de",
  off: "apagado",
  on: "encendido",
  optional: "opcional",
  page: "página",
  reset: "restablecer",
  required: "obligatorio",
  saveAlert: "Guarda o cancela la vista de edición.",
  search: "Buscar",
  select: "Seleccionar",
  success: "Éxito",
  to: "a",
  unknown: "desconocido",
  wasUpdated: "se actualizó",
  wasDeleted: "se eliminó",
  useSelectedTime: "usar hora seleccionada",
  yes: "sí",
  // #endregion
  
  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: {
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "普通话",
    ko: "한국어",
    nl: "nederlands",
  },

  cookie: {
    header: "cookies",
    context1: "Agrisys A/s utiliza cookies para los siguientes fines:",
    context2: "Al pulsar \"Aceptar todo\" aceptas nuestro uso de cookies. De lo contrario, se utilizará un mínimo de cookies necesarias para que el servicio funcione, por ejemplo, para gestionar el inicio de sesión y la obtención de datos desde la plataforma consys.",
    purpose1: "Apoyar la funcionalidad del sitio web, por ejemplo, recordando tu configuración respecto a cookies, idiomas preferidos, monedas, etc.",
    purpose2: "Realizar análisis estadísticos de tu uso del sitio web, por ejemplo, midiendo qué tipo de contenido ves y en qué haces clic.",
    accept: "Aceptar necesarias",
    acceptAll: "Aceptar todo"
  },

  // #region | Units
  units: {
    animal: "animal",
    animals: "animales",
    units: "unidades",
    capacity: "capacidad",
    cup: "vaso", 
    cups: "vasos", 
    date: "fecha", 
    day: "día",
    days: "días",
    g: "g",
    hour: "hora",
    hourAgo: "hace una hora",
    hours: "Horas",
    hoursAgo: "hace horas",
    kg: "kg",
    minutAgo: "hace un minuto",
    minutesAgo: "hace minutos",
    min: "min",
    milisec: "miliseg",
    pct: "PCT",
    sec: "seg",
    time: "tiempo",
    times: "veces",
    timeToday: "vez hoy",
    timesToday: "veces hoy",
    total: "total",
    energy: "energía",
    gramPerMinute: "gramos por minuto",
    lenght: "longitud"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "añadir",
    apply: "aplicar",
    cancel: "cancelar",
    commit: "confirmar",
    confirm: "confirmar",
    create: "crear",
    csv: "csv",
    deselectAll: "deseleccionar todo",
    details: "detalles",
    edit: "editar",
    excel: "excel",
    filter: "Filtrar",
    goBack: "volver",
    menu: "menú",
    move: "mover",
    next: "siguiente",
    options: "opciones",
    prev: "anterior",
    print: "imprimir",
    resetFilters: "restablecer filtros",
    save: "guardar",
    selectAll: "seleccionar todo",
    unit: "unidad",
    close: "cerrar", 
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "visión general",
    globalMenu: "menú global",
    systemMenu: "menú del sistema",
    attentions: "avisos",
    quickEntry: "entrada rápida",
    language: "idioma",
    [Pages.dashboard]: "panel",
    [Pages.kpi]: "kpi",
    [Pages.feedCurve]: "curva de alimentación",
    [Pages.feedCurves]: "curvas de alimentación",
    [Pages.components]: 'componentes',
    [Pages.componentsAlternatives]: "alternativas de componentes",
    [Pages.mixtures]: "mezclas",
    [Pages.silos]: "silos",
    [Pages.silosSettings]: "configuración de silos",
    [Pages.animal]: "animal",
    [Pages.animals]: "animales",
    [Pages.animalsGroups]: "grupos de animales",
    [Pages.reports]: "informes",
    [Pages.archive]: 'archivo',
    [Pages.logbook]: "registro",
    [Pages.globalSettings]: "configuración",
    [Pages.devices]: "dispositivos",
    [Pages.freeda_lf]: "visión general",
    [Pages.freeda_lf_sections]: 'ubicaciones', 
    [Pages.freeda_lf_settings]: 'configuración',
    [Pages.op_operations]: 'operaciones',
    [Pages.op_quickEntry]: 'Entrada rápida',
    [Pages.freeda_esf]: "visión general",
    [Pages.freeda_esf_sections]: "ubicaciones", 
    [Pages.freeda_esf_settings]: "configuración"
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "información del usuario",
    user: "usuario",
    userName: "Nombre de usuario",
    firstName: "Nombre",
    lastName: "Apellidos",
    phone: "Teléfono",
    email: "Correo electrónico",
    password: "Contraseña",
    repeatPassword: "Repetir contraseña",
    country: "País",
    address: "Dirección"
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "información de la granja",
    farmName: "nombre de la granja",
    city: "ciudad",
    street: "calle",
    phone: "teléfono",
    vat: "IVA",
    email: "correo electrónico"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "hito",
      milestones: "hitos",
      noMilestoneFound: "no se encontró ningún hito",
      animalsInMilestones: "animales en hitos",
      latestMilestone: "hito actual",
      milestoneDay: "día del hito actual",
      newMilestone: "Nuevo hito"
    },
    defaultMilestones: {
      farrowing: "Parto",
      insemination: "Inseminación",
      weaning: "Destete",
      movedToFarrowing: "Trasladado a parto"
    }
  },
  // #endregion

  // #region | Events
  events: { 
    events: "eventos", 
    eventType: "tipo", 
    eventDate: "fecha", 
    eventNote: "nota", 
    eventTime: "hora", 
    typeMissing: "falta el tipo", 
    dateMissing: "falta la fecha", 
    noteMissing: "falta la nota", 
    addEvent: "añadir evento", 
    animal: "animal", 
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "dispositivos",
    name: "nombre",
    cpuId: "id de cpu",
    type: "Tipo",
    connection: "conexión",
    system: "sistema",
    noControllersFound: "no se encontraron controladores LAN",
    lanControllers: "controladores LAN",
    newLcBoard: "nueva placa LC",
    boardName: "nombre de la placa",
    boardNameMissing: "falta el nombre de la placa", 
    powerSupplyMissing: "falta la fuente de alimentación", 
    maxAcPortsMissing: "faltan los puertos CA máximos", 
    noIoBoards: "no se encontraron placas de E/S",
    ioBoards: "placas de E/S",
    newIoBoard: "nueva placa de E/S",
    layout: "distribución",
    horizontal: "Horizontal",
    vertical: "Vertical",
    asc: "Ascendente",
    desc: "Descendente",
    columns: "columnas",
    rows: "filas",
    order: "orden",
    direction: "dirección",
    chooseIo: "elegir E/S",
    chooseRfidIo: "Elegir E/S del lector RFID",
    remainingInputs: "entradas restantes",
    remainingOutputs: "salidas restantes",
    aicoIo: "Placa de E/S",
    output: "Salida",
    input: "Entrada",
    board: "placa",
    moveBoard: "mover placa",
    noTerminals: "Sin terminales",
    terminalPort: "Puerto del terminal",
    pen: "Corral",
    ioSpecifications: "especificaciones de E/S",
    numbering: "numeración",
    manual: "manual",
    automatic: "automático",
    pattern: "patrón",
    topLeft: "arriba izquierda",
    topRight: "arriba derecha",
    bottomLeft: "abajo izquierda",
    bottomRight: "abajo derecha",
    startCorner: "esquina inicial",
    noLanController: "Sin controlador LAN",
    noCpuId: "Sin id de cpu",
    noSystem: "Sin sistema",
    server: "Servidor", 
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "iniciar sistema",
      systemControls: "controles del sistema",
      emergencyStop: "parada de emergencia",
      stopSystem: "detener sistema",
      startAll: "iniciar todo",
      startSection: "iniciar sección",
      startSelected: "iniciar seleccionados",
      calibrateSection: "calibrar sección",
      calibrateSelected: "calibrar seleccionados",
      emptySection: "vaciar sección",
      emptySelected: "vaciar seleccionados",
      clickPen: "Haz clic en cada corral que quieras seleccionar",
      clickStation: "Haz clic en cada estación que quieras seleccionar",
      unClickPen: "Haz clic en cada corral que quieras deseleccionar",
      orSelectAll: "O seleccionar todo",
      orDeselectAlle: "O deseleccionar todo",
      problem: "problema",
      problems: "problemas",
      warning: "advertencia",
      warnings: "advertencias",
      attention: "aviso",
      attentions: "avisos",
      attentionType: "Tipo de aviso",
      systemState: "Estado del sistema",
      staticFeeding: "Alimentación estática",
      nextFeeding: "Siguiente alimentación",
      resolvedWeight: "peso resuelto",
      noPensSelected: "No hay corrales seleccionados",
      noStationsSelected: "No hay estaciones seleccionadas", 
      feeding: "Alimentación",
      feedingFailed: "Error en la alimentación",
      calibrating: "Calibrando",
      calibratingFailed: "Error al calibrar",
      changeTime: "Cambiar hora",
      emptying: "Vaciando",
      emptyingFor: "Vaciando por",
      emptyingFailed: "Error al vaciar",
      controls: "Controles",
      confirmStop: "¿Quieres proceder con la parada de emergencia del sistema?",
      goToSystem: "ir al sistema",
      systemStatus: "estado del sistema",
      date: "fecha",
      level: "nivel",
      type: "tipo",
      inspect: "inspeccionar",
      delete: "eliminar",
      logid: "id de registro",
      system: "Sistema",
      motor: "Motor",
      animal: "Animal",
      alerts: "alertas",
      location_name: "Nombre de la ubicación",
      fk_lan_controllers: "FK controladores LAN",
      lan_controller_log_id: "ID de registro del controlador LAN",
      attention_message: "Mensaje de aviso",
      attention_time: "Hora del aviso",
      runningWith: "funcionando con",
      technicalData: "Datos técnicos",
      startLocation: "ubicación inicial",
      calibrateLocation: "calibrar ubicación", 
      gateControl: "control de puerta", 
      autotuneAntenna: "autoajustar antena", 
      openGate: "abrir puerta", 
      closeGate: "cerrar puerta", 
      blockGate: "bloquear puerta", 
      unblockGate: "desbloquear puerta", 
      autotuneSelected: "autoajustar seleccionados", 
      autoTuneFailed: "error en el autoajuste" 
    },
    states: {
      [AttentionTypes.good]: "En ejecución",
      [AttentionTypes.neutral]: "Apagado",
      [AttentionTypes.warning]: "Advertencia",
      [AttentionTypes.alert]: "Alerta"
    },
    createSystem: {
      createNewSystem: "crear nuevo sistema", 
      systemName: "nombre del sistema", 
      systemType: "tipo de sistema", 
      systemNameMissing: "falta el nombre del sistema", 
      systemTypeMissing: "falta el tipo de sistema", 
      systemLimitReached: "límite de sistemas alcanzado", 
      createSystem: "crear sistema" 
    },
    blueprint: {
      blueprint: "plano", 
      upload: "subir", 
      wrongType: "Error al procesar el archivo", 
      wrongSize: "El archivo es demasiado grande (máx. 500 kB)", 
      pleaseDropImage: "Arrastra un archivo JPEG", 
      pleaseSelectImage: "Selecciona un archivo JPEG", 
      dropImage: "Arrastra y suelta tu plano aquí", 
      browseImage: "O búscalo en tu ordenador", 
      chooseFile: "Elegir archivo",  
      chooseAgain: "elegir de nuevo"
    }
  },
  // #endregion

  // #region | Motor Specs
  motorSpecs: {
    general: {
      skipCnt: "recuento de saltos",
      skipTime: "tiempo de salto",
      powerConsumption: "consumo de energía",
      calibrationValue: "valor de calibración",
      rotationTime: "tiempo de rotación",
      statusMode: "modo de estado",
      noSkip: "Sin saltos",
      noPowerConsumption: "Sin consumo de energía",
      noCalibrationValue: "Sin valor de calibración",
      noRotationTime: "Sin tiempo de rotación",
      noStatusMode: "Sin modo de estado",
      pending: "pendiente",
      activated: "activado",
      skippedUntil: "Saltado hasta",
      noLiveData: "Sin datos en vivo"
    },
    terminalTypes: {
      input: "Entrada", 
      output: "Salida", 
      buttonInput: "Entrada de botón", 
      gateSensorInput: "Entrada del sensor de puerta", 
      digitalInput: "Entrada digital", 
      waterOutput: "Salida de agua", 
      inputMotor: "Motor de entrada", 
      cupMotorOutput: "Salida del motor de vaso", 
      cupMotorInput: "Entrada del motor de vaso", 
      gateMotorOutput: "Salida del motor de puerta", 
      gateMotorInput: "Entrada del motor de puerta", 
      rfidReader: "Lector RFID", 
      rfidReaderInput: "Entrada del lector RFID", 
      rfidReaderDeviceId: "ID del dispositivo del lector RFID", 
      sensorP: "Sensor P", 
      defaultMotor: "motor predeterminado",
      locationFeeder: "motor lf",
      activator: "activador",
      water: "agua"
    },
    terminalProgrammed: {
      disabled: "Desactivado",
      calibration: "Calibración",
      feedingOnFeedingTimes: "Alimentación según horarios",
      motorPassive: "Motor pasivo"
    }
  },
  // #endregion

  // #region | Params
  params: {
    animal: "Animal",
    animalId: "de animal ID",
    animal_number: "N.º de animal", 
    location: "Ubicación",
    location_id: "Ubicación ID",
    feedCurve: "Curva de alimentación",
    feedCurveId: "Curva de alimentación", 
    group: "Grupo",
    animal_group_id: "Grupo", 
    condition: "Condición",
    removeAnimals: "Mover animales",
    resetTotalConsumed: "Restablecer consumido total",
    manualFeedStart: "Inicio manual de alimentación",
    clearCalendarEvents: "Vaciar eventos del calendario",
    insemination: "Inseminación",
    weaning: "Destete",
    farrowing: "Parto",
    pregnancyCheck: "Chequeo de gestación",
    birthDate: "Fecha de nacimiento",
    pregnant: "Preñada",
    responderNo: "N.º de responder",
    responderNumber: "N.º de respondedor", 
    lifeNo: "N.º de vida",
    life_number: "N.º de vida",
    animalType: "Tipo de animal",
    milestone: "Hito",
    milestone_id: "Hito actual", 
    milestone_day: "Día del hito", 
    system: "Sistema",
    system_id: "Systema", 
    excess_remaining: "Faltan más de",
    animalRemainingToday: "Restante hoy", 
    animalRemainingYesterday: "Restante ayer", 
    animalConsumedToday: "Consumido hoy", 
    animalConsumedYesterday: "Consumido ayer", 
    animalMilestoneDay: "Día del hito actual", 
    animalCycleDayTotal: "Día total del ciclo", 
    section: "Sección", 
    reset_consumption: "Restablecer consumo", 
  },
  negativeParams: {
    animal: "Sin animal",
    animals: "Sin animales",
    animalId: "Sin n.º de animal",
    location: "Sin ubicación",
    feedCurve: "Sin curva de alimentación",
    group: "Sin grupo",
    condition: "Sin condición",
    component: "No Component",
    birthDate: "Sin fecha de nacimiento",
    pregnant: "No preñada",
    responderNo: "Sin n.º de responder",
    lifeNo: "Sin n.º de vida",
    animalType: "Sin tipo de animal",
    milestone: "Sin hito",
    system: "Sin sistema",
    ds: "Sin MS",
    energy: "Sin energía",
    limit: "Sin límite",
    gramPerMinute: "Sin gramos por minuto",
    priority: "Sin prioridad",
    protein: "Sin proteína",
  },
  // #endregion

  // #region | Configs
  configs: {
    stationStatus: {
      creation: "Creación",
      init: "Inicializando",
      termCheck: "Comprobación de terminal",
      calibrate: "Calibrar",
      idle: "Inactivo",
      waitingTag: "Esperando etiqueta",
      fetchFeeding: "Obtener alimentación",
      oneFeeding: "1 alimentación",
      spray: "Pulverización",
      feeding: "Alimentando",
      waitingLeave: "Esperando salida",
      blocked: "Bloqueado",
      disabled: "Deshabilitado",
      error: "Error",
      end: "Fin"
    },
    feedMotor: {
      init: "Initilazing",
      idle: "Idle",
      running: "Running",
      bookCal: "Book Calibrate",
      bookEmpty: "Book Empty",
      starting: "Starting",
      cal: "Calibrate",
      empty: "Empty",
      end: "End",
      retry: "Retry",
      safetyOne: "Safety 1",
      safetyTwo: "Safety 2",
      safetyThree: "Safety 3",
      error: "Error"
    },
    gateMotor: {
      unknown: "Unknown",
      noGate: "No Gate",
      gateClosed: "Gate closed",
      gateClosing: "Gate closing",
      gateOpen: "Gate open",
      gateOpening: "Gate opening"
    }
  },
  // #endregion

  // #region | Feed
  feed: {
    general: {
      feed: "pienso",
      feeding: "alimentación",
      remainingToday: "Restante hoy",
      remainingYesterday: "Restante ayer",
      waterUseToday: "Uso de agua hoy",
      notFed: "alimentado <20% en los dos últimos días",
      feedLastDays: "últimos 10 días",
      currentProgress: "progreso actual",
      fedLastPeriod: "alimentado último período",
      fedTotal: "alimentado total",
      feedConsumption: "consumo de pienso",
      feedBalance: "balance de pienso",
      consumedToday: "consumido hoy",
      consumedYesterday: "consumido ayer",
      expectedConsumption: "Consumo esperado",
      actualConsumption: "Consumo real" 
    },
    feedCurve: {
      feedCurve: "Curva de alimentación",
      active: "activo",
      noFeedCurve: "No se encontró curva de alimentación",
      default: "predeterminada",
      minFeedSpeed: "velocidad mínima de alimentación (g/min)",
      maxFeedSpeed: "velocidad máxima de alimentación (g/min)",
      feedSpeed: "velocidad de alimentación",
    },
    feedCorrection: {
      increased: "aumentado",
      decreased: "disminuido",
      disabled: "desactivado",
      feedCorrection: "Corrección de alimentación",
      feedCorrections: "Correcciones de alimentación",
    },
    feedSkip: {
      feedSkip: "salto de alimentación",
      skipFeeding: "saltar alimentación",
      noSkip: "sin salto de alimentación",
      skipForNow: "por ahora",
      planSkip: "planificar",
      planFeedSkip: "planificar salto de alimentación",
      standardSkip: "estándar",
      startFeeding: "iniciar alimentación",
      invalidDay: "día no válido",
      invalidTime: "hora no válida",
      endDateBeforeStartDate: "la fecha de fin es anterior a la fecha de inicio",
      endTimeBeforeStartTime: "la hora de fin es anterior a la hora de inicio",
      timeSpan: "intervalo de tiempo",
      timeAmount: "cantidad de tiempo",
      startDate: "fecha de inicio",
      endDate: "fecha de fin",
      startTime: "hora de inicio",
      endTime: "hora de fin",
      plannedSkip: "salto planificado",
      recentFeedSkipSuccess: "Estado de éxito del salto de alimentación reciente",
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      fullView: "vista completa",
      focus_view: "vista de enfoque",
      goToSiteList: "Ir a la lista de sitios",
      switchTofocus_view: "Cambiar a vista de enfoque",
      switchToFullView: "Cambiar a vista completa"
    },
    login: {
      login: "iniciar sesión",
      logOut: "Cerrar sesión",
      welcomeBack: "bienvenido de nuevo",
      notRegisteredYet: "¿Aún no estás registrado?",
      createNewuser: "crear nuevo usuario",
      forgotPassword: "¿Olvidaste la contraseña?",
      resetPassword: "restablecer contraseña",
      missingUserName: "falta el nombre de usuario",
      missingPassword: "falta la contraseña",
      couldNotLogin: "no se pudo iniciar sesión",
      noSitesFound: "no se encontraron sitios"
    },
    forgotPassword: {
      forgotPassword: "olvidé la contraseña",
      resetPassword: "restablecer contraseña",
      text: "Si no hay un correo electrónico asignado al nombre de usuario, ponte en contacto con soporte para más ayuda.",
      text2: "No cierres esta ventana antes de que finalice el proceso de restablecimiento.",
      noEmail: "Sin correo electrónico asignado",
      contactSupport: "contactar soporte",
      usernameRequired: "nombre de usuario requerido",
      noUsernameFound: "el nombre de usuario no existe"
    },
    resetPassword: {
      resetPassword: "restablecer contraseña",
      text: `Se ha enviado un código temporal a tu correo electrónico. Escríbelo a continuación para crear una nueva contraseña.`,
      temporaryCode: "Código temporal",
      newPassword: "Nueva contraseña",
      repeatPassword: "Repetir nueva contraseña",
      createNewPassword: "crear nueva contraseña",
      contactSupport: "contactar soporte",
      noPasswordRevieved: "¿No recibiste un código temporal?",
      newPasswordFail: "no se pudo crear la nueva contraseña"
    },
    createUser: {
      newUser: "usuario nuevo",
      missingUserName: "falta el nombre de usuario",
      missingPassword: "falta la contraseña",
      missingRepeatPassword: "por favor, repite la contraseña",
      passwordMismatch: "las contraseñas no coinciden",
      success: "éxito"
    },
    chooseSite: {
      chooseSite: "elegir sitio",
      siteName: "nombre del sitio",
      domain: "dominio",
      id: "id",
      tools: "herramientas"
    }
  },
  // #endregion

  // #region | Widgets
  widgets: {
    general: {
      noWidgets: "En este momento no hay widgets en esta página.",
      widgetOptions: "opciones del widget",
      manageWidgets: "gestionar",
      name: "Nombre",
      type: "Tipo",
      widgetPriority: "Prioridad",
      createNew: "crear nuevo",
      copyExisting: "copiar existente",
    },
    widgetTypes: {
      autoReports: "Informes automáticos",
      autoReportsAndMore: "Informes automáticos, etc.",
      graph: "Gráfico",
      progress: "Círculos de progreso",
    },
    graph: {
      noGraphSelected: "No se seleccionó ningún gráfico",
      graphIncludesStart: "El gráfico incluye todos los animales",
      graphIncludesEnd: "que tienen datos de consumo de pienso",
      animalsToInclude: "Animales a incluir según el sistema",
      last10Days: "Consumo de pienso de los últimos 10 días", 
      last10DaysComponent: "Consumo de pienso de los últimos 10 días por componente", 
    },
    autoReports: {
      autoReports: "Informes automáticos",
      navigatedFromSystem: "Navegado desde el sistema",
      add: "Agregar informe automático",
      addExisting: "agregar existente"
    }
  },
  // #endregion

  // #region | Penlist
  penList: {
    basicDisclaimer: "Mantén el ratón sobre un valor para ver el tipo de columna",
    editDisclaimer: "Edita un animal seleccionando nuevos valores",
    addDisclaimer: "Añade un animal desde el desplegable o elimínalo de nuevo con el icono de papelera",
    moveDisclaimer: "Mueve un animal a una nueva ubicación desde el desplegable o elimínalo de cualquier ubicación con el icono de papelera",
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "copiar curva de alimentación",
      createFeedCurve: "crear curva de alimentación",
      createFeedCurveFromScratch: "Crear curva de alimentación desde cero",
      feedCurveDetails: "detalles de la curva de alimentación",
      newFeedCurve: "nueva curva de alimentación",
      feedCurveName: "nombre de la curva de alimentación",
      fromFeedCurve: "de la curva de alimentación",
      feedCurveNameMissing: "falta el nombre de la curva de alimentación",
      goToFeedCurvePage: "ir a la página de curvas de alimentación" 
    },
    components: {
      components: "componentes",
      emptyText: "no se encontraron componentes",
      name: "Nombre del componente",
      readyMixture: "Listo para usar",
      priority: "Prioridad",
      ds: "MS",
      energy: "Energía",
      protein: "Proteína",
      gramPerMinute: "Gramos por minuto",
      limit: "Límite",
      newComponent: "nuevo componentes"
    },
    feedCurve: {
      spreading: "reparto",
      spreadings: "Repartos",
      noSpreading: "Sin reparto",
      settings: "configuración",
      day: "día",
      watchFeedCurve: "ver curva de alimentación",
      doNotPassFeed: "No pasar pienso",
      passFeed: "Pasar pienso",
      stimuli: "Estímulos",
      noStimuli: "Sin estímulos",
      addStimuli: "Añadir estímulo",
      singleStimuli: "Estímulo único",
      repeatStimuli: "Repetir estímulo",
      maxAmount: "cantidad máxima del período (kg)",
      remainingFeed: "pienso restante",
      maxFeedToPass: "kg máximos a pasar",
      max: "máx.",
      feeding: "alimentación",
      feedings: "alimentaciones",
      feedStimuli: "estímulos de alimentación",
      minutesApart: "minutos de separación",
      addTime: "añadir hora",
      saveChanges: "guardar cambios",
      resetChanges: "restablecer cambios",
      feedCurveLenght: "Longitud",
      feedLimit: "Límite de alimentación",
      animalCount: "Animales",
      consumedToday: "Consumido hoy",
      usage: "uso actual",
      unknownMilestoneAndDay: "Hito y día desconocidos", 
      deleteFeedcurve: "eliminar curva de alimentación", 
      confirmDelete: "¿Seguro que quieres eliminar esta curva de alimentación?", 
      noFeedcurves: "No se encontraron curvas de alimentación" 
    }
  },
  // #endregion
  
  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "animales",
      emptyText: "No se encontraron animales",
      quickEntry: "entrada rápida",
      newAnimal: "animal nuevo",
      viewChanges: "ver cambios",
      action: "acción",
      selectAnimals: "seleccionar animales",
      missingAnimalNo: "falta el n.º de animal",
      missingResponderNo: "falta el n.º de responder",
      kgFedMore: "kg alimentados por encima de lo esperado",
      noAnimalsMatchTheSelection: "Ningún animal coincide con la selección",
      responderLengt: "el número de respondedor debe tener 15 caracteres", 
      lifeNoLengt: "el número de vida no debe superar 9 caracteres", 
      columns: "Columnas", 
      priority: "Prioridad", 
      tablePreferences: "preferencias de tabla", 
      resetConsumptionDisclaimer: "Nota: restablecer consumo solo está disponible para ESF", 
    },
    animalGroups: {
      group: "grupo",
      numberOfAnimals: "Número de animales",
      createGroup: "crear grupo",
      newGroup: "grupo nuevo",
      groupName: "nombre del grupo",
    },
    animal: {
      animal: "animal",
      basicInfo: "información básica",
      noAnimalSelected: "ningún animal seleccionado",
      noAnimalsSelected: "no hay animales seleccionados",
      addAnimal: "añadir animal",
      addAnimalToPen: "añadir animal al corral",
      pen: "Corral",
      moveAnimal: "mover animal",
      moveAnimals: "mover animales",
      moveAnimalFromPen: "mover animal al corral",
      goToAnimal: "ir a la página del animal",
      totalCycleDay: "día total del ciclo",
      marking: "marcado",
      noTimeline: "sin cronología",
      timeline: "cronología",
      viewTimeline: "ver cronología",
      born: "nacido",
      timelineShows: "la cronología muestra la paridad",
      parity: "paridad",
      deleteAnimal: "eliminar animal", 
      deleteConfirm: "¿Seguro que quieres eliminar este animal?", 
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "Plantilla",
      templateName: "Nombre de la plantilla",
      addTemplate: "añadir plantilla",
      copyTemplate: "copiar plantilla",
      createReport: "crear informe",
      createNewReport: "Comenzar un informe nuevo desde cero",
      newTemplate: "nueva plantilla",
      newReport: "informe nuevo",
      dataLevel: "Nivel de datos",
      filterParameter: "Parámetro de filtro",
      dataParameter: "parámetro de datos",
      reportName: "nombre del informe",
      archiveReport: "archivar informe",
      startDate: "fecha de inicio",
      endDate: "fecha de fin",
      showInReport: "Mostrar en el informe",
      fromTemplate: "desde plantilla",
      noReportFound: "no se encontró informe",
      noDataParameterFound: "no se encontró parámetro de datos",
      unknownCondition: "condición desconocida",
      unknownAnimalGroup: "grupo desconocido",
      noFilterParameterFound: "no se encontraron parámetros de filtro",
      saveAsTemplate: "guardar como plantilla",
    },
    manageTemplates: { 
      templateOptions: "opciones de plantilla", 
      manageTemplates: "gestionar", 
      copyExisting: "copiar existente", 
      noTemplates: "En este momento no hay widgets en esta página.",
    }, 
    report: {
      report: "informe",
      editReport: "editar informe",
      unArchiveReport: "desarchivar informe",
      saveAsTemplate: "guardar como plantilla",
      noReport: "no se encontró informe",
      noReports: "No tienes informes archivados",
      deleteReport: "eliminar informe", 
      deleteConfirm: "¿Seguro que quieres eliminar este informe?" 
    },
    reportColumn: {
      system: "Sistema",
      system_id: "Sistema",
      animal_id: "Animal",
      animal_button: "Animal",
      location: "Ubicación",
      location_id: "Ubicación",
      section_id: "Sección",
      section: "Sección",
      feedcurve_id: "Curva de alimentación",
      feedCurveId: "Curva de alimentación",
      animal_number: "N.º de animal",
      cycle: "Ciclo",
      correction: "Corrección",
      feedcurve_milestones: "Hitos de la curva de alimentación",
      milestone_day: "Día del hito",
      condition: "Condición",
      animal_type: "Tipo de animal",
      responder_number: "N.º de responder",
      life_number: "N.º de vida",
      birthday: "Fecha de nacimiento",
      animal_group_name: "Grupo",
      milestone_name: "Hito",
      milestone_id: "Hito",
      animal_group_id: "Grupo",
      group_id: "Grupo",
      group_name: "Grupo",
      system_id_for_report: "ID de sistema para informes",
      system_name: "Sistema",
      totalPeriodConsumption: "Consumo total del período",
      consumed: "Consumido",
    },
    archive: {
      archive: "archivo",
      filterByNumber: "número de informe",
      filterByName: "nombre de informe alfabético",
      archivedReport: "Informe archivado",
      noStartDateFound: "No se encontró fecha de inicio",
      noEndDateFound: "No se encontró fecha de fin",
    },
    errorMessages: { 
      missingName: "falta el nombre", 
      missingStartDate: "falta la fecha de inicio", 
      missingEndDate: "falta la fecha de fin", 
      missingDataLevel: "falta el nivel de datos", 
      missingFilterParameters: "faltan parámetros de filtro", 
    } 
  },
  // #endregion

  // #region | Logbook pages
  logPages: { 
    logbook: { 
      problem: "Problema", 
      warning: "Advertencia", 
      info: "Información", 
      debug: "Depuración", 
      system: "Sistema", 
      motor: "Motor", 
      animal: "Animal", 
      time: "hora", 
      level: "nivel", 
      type: "tipo", 
      message: "mensaje", 
      location: "ubicación", 
      controller: "controlador", 
      allControllers: "todos los controladores", 
      controllerName: "nombre del controlador", 
      deviceName: "nombre del dispositivo", 
      lanControllers: "controladores LAN", 
      getLog: "obtener registro", 
      noLogsAvailable: "No se encontraron registros", 
      responder: "respondedor", 
    }, 
  }, 
// #endregion
    
  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "Imperial",
      metric: "Métrico",
      saveChanges: "guardar cambios",
      discardChanges: "descartar cambios",
      userManagement: "gestión de usuarios",
      workerManagement: "gestión de trabajadores",
      timeZone: "zona horaria",
      feedDayStart: "inicio del día de alimentación",
      remove: "eliminar",
      emailAttentionDisclaimerWorker: "Elija de qué sistemas debe recibir atención su trabajador", 
      emailAttentionDisclaimerUser: "Elige de qué sistemas quieres recibir avisos", 
      settingsFor: "ajustes para", 
      systemNotifications: "notificaciones del sistema" 
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "secciones",
      pens: "corrales",
      animals: "animales",
      sectionNo: "N.º de sección",
      pen: "Corral",
    },
    sections: {
      section: "sección",
      sections: "secciones",
      map: "mapa",
      animalAmount: "número de animales",
      penValueHeaders: "mantén el ratón sobre un valor para ver el tipo de columna",
      sectionNotFound: "sección no encontrada",
      emptyPen: "Corral vacío",
      feeder: "comedero",
      inThisPen: "en este corral",
      activations: "activaciones",
      lastActivated: "última activación",
      newSection: "nueva sección",
      sectionName: "nombre de la sección",
      firstPenNo: "primer n.º de corral",
      penAmount: "número de corrales",
      clickOnPen: "Haz clic en un corral para añadirlo o eliminarlo de nuevo.",
      penContent: "contenido del corral",
      feederOnly: "Solo comedero",
      water: "Agua",
      activator: "Activador",
      feederOutput: "Salida del comedero",
      waterOutput: "Salida de agua",
      activatorInput: "Entrada del activador",
      since: "desde",
      redirect: "Esto te redirigirá a la página del animal.",
      expand: "expandir",
      collapse: "contraer",
      noSections: "No se encontraron secciones",
      noAnimal: "Sin animal",
      editSection: "editar sección", 
      clickPen: "Haz clic en cada corral que quieras editar", 
      clicStation: "Haz clic en cada estación que quieras editar", 
      deleteSectionConfirm: "¿Seguro que quieres eliminar esta sección?", 
      priority: "Prioridad", 
      sectionNameMissing: "falta el nombre de la sección", 
      pen: "Corral",
    },
    settings: {
      dailyRotation: "rotación diaria",
      dailyRotationDisclaimer: "NB: Si la ubicación está vacía o el animal no tiene asignada una curva de alimentación, el motor realizará una rotación diaria con fines de servicio.",
      feedInSilos: "pienso en silos",
      attentionLimit: "límite de aviso",
      feedAmount: "cantidad de pienso", 
      defFeedAmount: "cantidad de pienso predeterminada (g)", 
      deleteSystem: "eliminar sistema", 
      deleteDisclaimer: "¿Seguro que quieres eliminar este sistema?", 
      systemName: "nombre del sistema" 
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
     pens: "corrales", 
      station: "Estación", 
      stations: "estaciones",
      animals: "animales", 
      motor: "motor", 
      component: "componente", 
      noComponent: "Sin componente", 
      include: "incluir", 
    },
    sections: {
      pen: "corral",
      pens: "corrales",
      station: "estación",
      stationFeeding: "alimentación", 
      feedMotor: "motor de pienso",
      feedSensor: "sensor de pienso",
      gateMotor: "motor de puerta",
      gateSensor: "sensor de puerta",
      inThisStation: "en esta estación",
      previously: "anteriormente",
      feedComponents: "componentes de pienso",
      stationLastDays: "últimos 10 días",
      stationLog: "registro",
      noPens: "No se encontraron corrales", 
      currentlyInThisPen: "actualmente en este corral", 
      animal: "Animal", 
      noAnimal: "Sin animal", 
      unknownAnimal: "Animal desconocido", 
      fedToday: "alimentado hoy", 
      usesToday: "usos hoy", 
      stationsState: "estado de la estación", 
      available: "disponible", 
      consumed: "consumido", 
      number: "n.º", 
      water: "agua", 
      waterAddedPrCup: "agua añadida por vaso", 
      waterDelay: "retraso de agua", 
      gateAdjustment: "ajuste de puerta", 
      delayTimeClosingGate: "tiempo de retraso al cerrar la puerta",
      indetificationValidTime: "tiempo de validez de identificación", 
      entryTime: "hora de entrada", 
      feedMotors: "motores de pienso", 
      noFeedBlockTime: "tiempo sin bloqueo de pienso", 
      lastFeedBlockTime: "último tiempo de bloqueo de pienso",
      motorComponents: "componentes del motor", 
      motor: "motor", 
      missing: "falta", 
    },
    newSection: {
      firstStationNo: "N.º de primera estación", 
      firstColumnExit: "salida de primera columna", 
      secondColumnExit: "salida de segunda columna", 
      numberOfFeeders: "Número de comederos",
      water: "Agua", 
      button: "Botón", 
      waterOutput: "Salida de agua", 
      buttonInput: "Entrada de botón", 
      feederOutput: "Salida de comedero", 
      feederInput: "Entrada de comedero", 
      gateMotorOutput: "Salida del motor de puerta", 
      gateMotorInput: "Entrada del motor de puerta", 
      gateSensor: "Sensor de puerta", 
      newPen: "nuevo corral", 
      penName: "nombre del corral", 
      numberOfStations: "número de estaciones", 
      clickOnStation: "Haz clic en una estación para añadirla o volver a quitarla.", 
      stationContent: "contenido de la estación", 
      editPen: "editar corral", 
      clickStationToEdit: "Haz clic en cada estación que quieras editar", 
      station: "Estación", 
      penNameMissing: "falta el nombre del corral", 
      editFailed: "error al editar", 
      noStationsSelected: "no hay estaciones seleccionadas", 
      deletePenConfirm: "¿Seguro que quieres eliminar este corral?",
    },
    settings: {
    },
    systemControl: {

    }
  },
  // #endregion

  // #region | Focus View Pages
  focus_viewPages: {
    location: "ubicación",
    system: "sistema",
    section: "sección",
    inThisPen: "en este corral",
    today: "hoy",
    pen: "Corral",
    since: "desde",
    day: "Día",
    moveAnimal: "mover animal",
    newLocation: "nueva ubicación",
    emptyPen: "Corral vacío",
  }
  // #endregion
}
export default Texts